<template>
  <div class="videoDetailsBox">
    <div class="videoDetailsContent">
      <div class="videoTop">
        <div id="video-container" class="video"></div>
      </div>
      <div class="videoControl">
        <div class="videoControlLeft">
          <div class="videoControlBtn">
            <div class="videoControlBtnLeft" v-longpress="() => {
              startMonitor(9);
            }
              " @touchend="stopMonitor(9)">
              <van-icon name="minus" class="videoControlBtnIcon" />
            </div>
            <div class="videoControlBtnCenter">{{ $t("common.zoom") }}</div>
            <div class="videoControlBtnRight" v-longpress="() => {
              startMonitor(8);
            }
              " @touchend="stopMonitor(8)">
              <van-icon name="plus" class="videoControlBtnIcon" />
            </div>
          </div>
          <div class="videoControlBtn">
            <div class="videoControlBtnLeft" v-longpress="() => {
              startMonitor(11);
            }
              " @touchend="stopMonitor(11)">
              <van-icon name="minus" class="videoControlBtnIcon" />
            </div>
            <div class="videoControlBtnCenter">{{ $t("common.focalLength") }}</div>
            <div class="videoControlBtnRight" v-longpress="() => {
              startMonitor(10);
            }
              " @touchend="stopMonitor(10)">
              <van-icon name="plus" class="videoControlBtnIcon" />
            </div>
          </div>
        </div>
        <div class="videoControlRight">
          <div class="videoDirection">
            <div class="videoDirectionCenter" @click="screenshot">
              <van-icon name="photograph" class="videoDirectionCenterIcon" />
            </div>
            <div class="videoDirectionItem videoDirectionTop" v-longpress="() => {
              startMonitor(0);
            }
              " @touchend="stopMonitor(0)">
              <van-icon name="arrow-up" class="videoDirectionItemIcon" />
            </div>
            <div class="videoDirectionItem videoDirectionDown" v-longpress="() => {
              startMonitor(1);
            }
              " @touchend="stopMonitor(1)">
              <van-icon name="arrow-down" class="videoDirectionItemIcon" />
            </div>
            <div class="videoDirectionItem videoDirectionLeft" v-longpress="() => {
              startMonitor(2);
            }
              " @touchend="stopMonitor(2)">
              <van-icon name="arrow-left" class="videoDirectionItemIcon" />
            </div>
            <div class="videoDirectionItem videoDirectionRight" v-longpress="() => {
              startMonitor(3);
            }
              " @touchend="stopMonitor(3)">
              <van-icon name="arrow" class="videoDirectionItemIcon" />
            </div>
          </div>
        </div>
      </div>
      <div class="videoList">
        <div class="listTop">
          <div class="listTitle">{{ $t("common.monitoringList") }}</div>
          <div class="listRight" @click="toPage">
            {{ $t("common.cloudPortal") }}
            <div class="listRightIcon">
              <van-icon name="arrow" class="videoDirectionItemIcon" />
            </div>
          </div>
        </div>
        <div class="videoListBox">
          <div class="videoListItem" :class="{ videoActvie: monitorActive == index }"
            v-for="(listItem, index) in monitorList" :key="listItem.id" @click.stop="changeVideoItem(index)">
            {{ listItem.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Dialog, Toast } from "vant";
import { EZUIKitPlayer } from "ezuikit-js";
import uniWebview from "@dcloudio/uni-webview-js";
import { ROLE_OPERATE } from "../config/common.js"
var player = null;

var themeData = {
  header: {
    color: "#1890ff",
    activeColor: "#FFFFFF",
    backgroundColor: "#000000",
    btnList: [
      // {
      //   iconId: "deviceID",
      //   part: "left",
      //   defaultActive: 0,
      //   memo: "顶部设备序列号",
      //   isrender: 1,
      // },
      // {
      //   iconId: "deviceName",
      //   part: "left",
      //   defaultActive: 0,
      //   memo: "顶部设备名称",
      //   isrender: 1,
      // },
      // {
      //   iconId: "cloudRec",
      //   part: "right",
      //   defaultActive: 0,
      //   memo: "云存储",
      //   isrender: 0,
      // },
      // {
      //   iconId: "rec",
      //   part: "right",
      //   defaultActive: 0,
      //   memo: "SD卡回放",
      //   isrender: 0,
      // },
    ],
  },
  footer: {
    color: "#FFFFFF",
    activeColor: "#1890FF",
    backgroundColor: "#00000021",
    btnList: [
      // {
      //   iconId: "play",
      //   part: "left",
      //   defaultActive: 1,
      //   memo: "播放",
      //   isrender: 1,
      // },
      // {
      //   iconId: "capturePicture",
      //   part: "left",
      //   defaultActive: 0,
      //   memo: "截屏按钮",
      //   isrender: 1,
      // },
      // {
      //   iconId: "sound",
      //   part: "left",
      //   defaultActive: 0,
      //   memo: "声音按钮",
      //   isrender: 1,
      // },
      // {
      //   iconId: "pantile",
      //   part: "left",
      //   defaultActive: 0,
      //   memo: "云台控制按钮",
      //   isrender: 1,
      // },
      // {
      //   iconId: "recordvideo",
      //   part: "left",
      //   defaultActive: 0,
      //   memo: "录制按钮",
      //   isrender: 1,
      // },
      // {
      //   iconId: "talk",
      //   part: "left",
      //   defaultActive: 0,
      //   memo: "对讲按钮",
      //   isrender: 1,
      // },
      // {
      //   iconId: "zoom",
      //   part: "left",
      //   defaultActive: 0,
      //   memo: "电子放大",
      //   isrender: 1,
      // },
      // {
      //   iconId: "hd",
      //   part: "right",
      //   defaultActive: 0,
      //   memo: "清晰度切换按钮",
      //   isrender: 1,
      // },
      // {
      //   iconId: "webExpend",
      //   part: "right",
      //   defaultActive: 0,
      //   memo: "网页全屏按钮",
      //   isrender: 1,
      // },
      {
        iconId: "expend",
        part: "right",
        defaultActive: 0,
        memo: "全局全屏按钮",
        isrender: 1,
      },
    ],
  },
};
export default {
  name: "Player",
  components: {
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    Toast,
  },
  mounted() {
    console.log("监控组件加载完毕");
    this.receiveFromUni();
  },
  data() {
    return {
      diyId: "", // 父元素传过来的diyId
      userId: "", // 父元素传过来的userId
      monitorActive: 0, // 当前激活的监控索引
      monitorList: [], // 监控列表
      accessToken: "", // 萤石云需要的token
      playerUrl: "", // 直播推流地址
      monitorInfo: {}, // 监控信息对象
      role: [], // 用户权限字符集
      ptzEmun: {
        0: "ptz_top_bottom",
        1: "ptz_top_bottom",
        2: "ptz_left_right",
        3: "ptz_left_right",
        8: "ptz_zoom",
        9: "ptz_zoom",
        10: "ptz_focus",
        11: "ptz_focus",
      }, // 萤石云云台操作枚举
    };
  },
  computed: {
    ptzMessage() {
      return {
        ptz_top_bottom: this.$t("player.ptz_top_bottom"),
        ptz_left_right: this.$t("player.ptz_left_right"),
        ptz_zoom: this.$t("player.ptz_zoom"),
        ptz_focus: this.$t("player.ptz_focus"),
      }
    }, // 云台操作提示信息
  },
  methods: {
    /**
         * 获取用户权限字符集
         */
    async getRole() {
      try {
        const res = await this.$api.getRoleByUserId(this.userId);
        if (res.code != "200") {
          Toast(res.msg);
        } else {
          this.role = [res.msg] || [];
        }
      } catch (error) {
        console.error("错误", error);
      }
    },
    /**
     * 公共 - 校验用户权限
     * 一般是操作性质的动作之前会验证
     */
    checkUserRole(roleKey = ROLE_OPERATE) {
      const roleList = this.role || [];
      if (roleList.includes(roleKey)) {
        return true;
      } else {
        Toast(this.$t("warning.noPermission"));
        return false;
      }
    },
    changeVideoItem(index) {
      this.monitorActive = index;
      this.initMonitor();
    },
    /**
     * 初始化监控功能
     */
    async initMonitor() {
      if (player) {
        this.destroy();
      }
      await this.getPlayerUrl(this.monitorList[this.monitorActive]);
      if (!this.playerUrl) {
        Toast(this.$t("warning.noVideo"));
        return;
      }
      player = new EZUIKitPlayer({
        id: "video-container", // 视频容器ID
        accessToken: this.accessToken,
        url: this.playerUrl,
        // template: "pcLive", // simple: 极简版; pcLive: pc直播; pcRec: pc回放; mobileLive: 移动端直播; mobileRec: 移动端回放;security: 安防版; voice: 语音版;
        handleError: (error) => {
          console.error("handleError", error);
        },
        download: false, // 是否自动下载图片至本地
        env: {
          domain: "https://open.ys7.com",
        },
        streamInfoCBType: 1,
        themeData: themeData, //上面的对象内容
      });
      window.player = player;
      this.capacityMonitor();
    },
    /**
     * 获取设备能力集
     */
    async capacityMonitor() {
      try {
        const res = await this.$api.ptzCapacity({
          accessToken: this.accessToken, //accesstoken码，一般一周过期
          deviceSerial: this.monitorList[this.monitorActive].serialNumber, //序列号
        });
        if (res.code !== "200") {
          Toast(res.msg);
        }
        this.monitorInfo = res.data;
      } catch (error) {
        console.error("错误", error);
      }
    },
    /**
     * 开始监控
     * @param num 操作命令：0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-物理放大，9-物理缩小，10-调整近焦距，11-调整远焦距，16-自动控制
     * @returns 无返回值
     */
    async startMonitor(num) {
      if (!this.checkUserRole()) return;
      if (!this.verfiyPZT(num)) {
        return;
      }
      try {
        const res = await this.$api.ptzStart({
          accessToken: this.accessToken, //accesstoken码，一般一周过期
          speed: 1, //旋转速度
          direction: num, //方向，传入数字，对应数字在api文档有
          channelNo: this.monitorList[this.monitorActive].channelNumber, // 通道号
          deviceSerial: this.monitorList[this.monitorActive].serialNumber, //序列号
        });
        if (res.code !== "200") {
          Toast(res.msg);
        }
      } catch (error) {
        console.error("错误", error);
      }
    },
    /**
     * 结束监控
     * @param num 操作命令：0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-物理放大，9-物理缩小，10-调整近焦距，11-调整远焦距，16-自动控制
     * @returns 无返回值
     */
    async stopMonitor(num) {
      if (!this.verfiyPZT(num, false)) {
        return;
      }
      try {
        const res = await this.$api.ptzStop({
          accessToken: this.accessToken, //accesstoken码，一般一周过期
          direction: num, //方向，传入数字，对应数字在api文档有
          channelNo: this.monitorList[this.monitorActive].channelNumber, // 通道号
          deviceSerial: this.monitorList[this.monitorActive].serialNumber, //序列号
        });
      } catch (error) {
        console.error("错误", error);
      }
    },
    /**
     * 截取当前播放器的屏幕截图
     */
    screenshot() {
      if (!this.checkUserRole()) return;
      Dialog.confirm({
        title: this.$t("common.screenshotConfirm"),
        message: this.$t("tips.saveScreenshot"),
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
      })
        .then(() => {
          var capturePicturePromise = player.capturePicture(
            `${new Date().getTime()}`
          );
          capturePicturePromise.then((data) => {
            uniWebview.postMessage({
              data: {
                webViewType: "download",
                ...data,
              },
            });
            uniWebview.navigateBack();
          });
        })
        .catch((action) => { });
    },
    /**
     * 验证云台类型
     * @param num 云台类型编号
     * @param flag 云台类型是否启用，默认为 true。如果为 false，则不显示警告信息
     * @returns 如果云台类型已启用，则返回 true；否则返回 false，并显示警告信息
     */
    verfiyPZT(num, flag = true) {
      const pztType = this.ptzEmun[num];
      if (this.monitorInfo[pztType] === "1") {
        return true;
      } else {
        if (flag) {
          Toast.fail(this.ptzMessage[pztType]);
        }
        return false;
      }
    },
    /**
     * 跳转到目标页面
     * 使用uni.webView.postMessage方法向目标页面发送消息，以触发目标页面的跳转。
     * 如果当前环境不支持uni.webView，则在控制台输出"不支持uni.webview"。
     */
    toPage() {
      Toast(this.$t("warning.underDevelopment"));
      return;
      Dialog.confirm({
        title: this.$t("common.jumpConfirm"),
        message: this.$t("tips.jumpToCloud"),
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
      })
        .then(() => {
          uniWebview.postMessage({
            data: {
              webViewType: "topage",
            },
          });
          uniWebview.navigateBack();
        })
        .catch((action) => { });
    },
    /**
     * 销毁播放器实例并重置播放器对象
     */
    destroy() {
      player.destroy();
      player = null;
    },
    /**
     * 解析uniapp传递过来的数据
     */
    receiveFromUni() {
      const urlParams = new URLSearchParams(window.location.search);
      const parsed = urlParams.get("id");
      const token = urlParams.get("token") || "";
      const userId = urlParams.get("userId") || "";
      const locales = urlParams.get("locales") || "zh-CN"; // 国际化
      this.$i18n.locale = locales;
      localStorage.setItem("token", token);
      this.diyId = parsed || "";
      this.userId = userId || "";
      if (this.diyId) {
        this.getMonitorList();
      }
      this.getRole();
    },
    /**
     * 获取监控列表
     */
    async getMonitorList() {
      const _this = this;
      try {
        const res = await this.$api.cameraList({
          diyId: this.diyId, //diyid
        });
        if (res.code != "200") {
          Toast(res.msg);
        } else {
          _this.monitorList = res.data || [];
          if (_this.monitorList.length > 0) {
            _this.getAccessToken();
          }
        }
      } catch (error) {
        console.error("错误", error);
      }
    },
    /**
     * 获取accessToken
     */
    async getAccessToken() {
      try {
        const res = await this.$api.yingshiToken({
          appKey: this.monitorList[this.monitorActive].appkey, // appKey
          appSecret: this.monitorList[this.monitorActive].appsecret, // appSecret
        });
        if (res.code != "200") {
          Toast(res.msg);
        } else {
          this.accessToken = res.msg || "";
          this.initMonitor();
        }
      } catch (error) {
        console.error("错误", error);
      }
    },
    /**
     * 获取摄像头推流地址
     *
     * @param {Object} item - 项目对象
     * @returns {String} 返回摄像头推流地址
     */
    async getPlayerUrl(item) {
      try {
        const res = await this.$api.getAddress({
          appKey: item.appkey, // appKey
          appSecret: item.appsecret, // appSecret
          deviceSerial: item.serialNumber, // 序列号
          channelNo: Number(item.channelNumber), // 通道号
        });
        if (res.code != "200") {
          Toast(res.msg);
        } else {
          this.playerUrl = res.data.msg || "";
        }
      } catch (error) {
        console.error("错误", error);
      }
    },
  },
};
</script>

<style scoped>
.videoDetailsBox {
  width: 100%;
  height: 100vh;
  padding: 0 10px 20px;
  box-sizing: border-box;
  background: linear-gradient(167deg,
      rgba(42, 130, 228, 1) 0%,
      rgba(255, 255, 255, 1) 100%);
  background-repeat: repeat;
  background-size: normal;
  display: flex;
  flex-direction: column;
}

.videoDetailsContent {
  margin-top: 30px;
  width: 100%;
  height: 0;
  flex: 1;
  border-radius: 24px 24px 0 0;
  overflow: hidden;
  background: rgba(242, 242, 242, 1);
  border: 1px solid rgba(242, 242, 242, 1);
  backdrop-filter: blur(12px);
  display: flex;
  flex-direction: column;
  padding: 15px;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
}

.videoTop {
  width: 100%;
  height: 180px;
  border-radius: 5px;
  overflow: hidden;
}

.video {
  width: 100%;
  height: 100%;
  background: #e4e4e4;
}

.videoControl {
  width: 100%;
  min-height: 103px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 10px;
  padding: 20px 10px;
  box-sizing: border-box;
}

.videoControlLeft {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.videoControlBtn {
  width: 137px;
  height: 33px;
  border-radius: 50px;
  background: linear-gradient(180deg,
      rgba(245, 250, 255, 1) 0%,
      rgba(232, 235, 235, 1) 100%);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.videoControlBtnLeft {
  min-width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.videoControlBtnIcon {
  font-size: 10px;
  color: #a6a6a6;
  font-weight: bold;
}

.videoControlBtnCenter {
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  color: rgba(42, 130, 228, 1);
}

.videoControlBtnRight {
  min-width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.videoControlRight {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.videoDirection {
  width: 103px;
  height: 103px;
  border-radius: 50%;
  background: linear-gradient(180deg,
      rgba(245, 250, 255, 1) 0%,
      rgba(232, 234, 234, 1) 100%);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.videoDirectionCenter {
  width: 35px;
  height: 35px;
  background: rgba(255, 255, 255, 1);
  box-shadow: inset 0px 0px 5px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.videoDirectionCenterIcon {
  font-size: 20px;
  color: #366fff;
  font-weight: bold;
}

.videoDirectionItemIcon {
  font-size: 13px;
  color: #a6a6a6;
  font-weight: bold;
}

.videoDirectionItem {
  width: 34px;
  height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
}

.videoDirectionTop {
  top: 0;
  left: 34px;
}

.videoDirectionDown {
  bottom: 0;
  left: 34px;
}

.videoDirectionLeft {
  top: 34px;
  left: 0;
}

.videoDirectionRight {
  top: 34px;
  right: 0;
}

.videoList {
  width: 100%;
  height: auto;
  background: #ffffff;
  padding: 20px 10px;
  box-sizing: border-box;
}

.listTop {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.listTitle {
  font-size: 16px;
  font-weight: 400;
  color: rgba(56, 56, 56, 1);
}

.listRight {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
}

.listRightIcon {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1.5px solid rgba(166, 166, 166, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.videoListBox {
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 10px;
}

.videoListItem {
  width: 100%;
  height: 27px;
  border-radius: 5px;
  background: rgba(225, 238, 252, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: rgba(56, 56, 56, 1);
}

.videoActvie {
  background: linear-gradient(90deg,
      rgba(41, 128, 227, 1) 0%,
      rgba(93, 160, 252, 1) 100%);
  color: #ffffff;
}
</style>
